import { JALALI_MONTHS, toFa } from "./clubFormat";

// Jalali month + day picker that reads/writes "MM-DD" (or "" for none).
export default function BirthdayField({ value, onChange, idPrefix = "birthday" }) {
  const [month = "", day = ""] = value ? value.split("-") : [];

  const update = (nextMonth, nextDay) => {
    if (!nextMonth || !nextDay) {
      onChange(nextMonth || nextDay ? `${nextMonth || ""}-${nextDay || ""}` : "");
      return;
    }
    onChange(`${nextMonth}-${nextDay}`);
  };

  const maxDay = Number(month) > 6 ? (Number(month) === 12 ? 29 : 30) : 31;
  const selectClass =
    "h-10 min-w-0 flex-1 rounded-lg border border-gray-200 bg-white px-2 text-sm text-gray-800 focus:border-primary focus:outline-none focus:ring-4 focus:ring-primary/10";

  return (
    <div className="flex gap-2">
      <select
        id={`${idPrefix}-day`}
        aria-label="روز تولد"
        value={day}
        onChange={(event) => update(month, event.target.value)}
        className={selectClass}
      >
        <option value="">روز</option>
        {Array.from({ length: maxDay }, (_, index) => {
          const d = String(index + 1).padStart(2, "0");
          return <option key={d} value={d}>{toFa(index + 1)}</option>;
        })}
      </select>
      <select
        id={`${idPrefix}-month`}
        aria-label="ماه تولد"
        value={month}
        onChange={(event) => update(event.target.value, day)}
        className={selectClass}
      >
        <option value="">ماه</option>
        {JALALI_MONTHS.map((name, index) => {
          const m = String(index + 1).padStart(2, "0");
          return <option key={m} value={m}>{name}</option>;
        })}
      </select>
    </div>
  );
}

export const isBirthdayComplete = (value) => !value || /^\d{2}-\d{2}$/.test(value);
